<script lang='ts'>
    import ActivityMap from "../Activities/ActivityMap.svelte";
    import { SelectSlider } from "@/Common";
    import Am5Loader from "../Util/Am5Loader.svelte";
    import { MpaAnalyticsTable } from "./ProgramElements";
    import { Separator } from "$lib/components/ui/separator";
    import { type MapController, type Polyline } from "@/Common/constants";
    import type { SummaryData } from "@/Activities/ActivityAnalytics";
    import * as Sheet from "$lib/components/ui/sheet/index.js";
    import * as Tabs from "$lib/components/ui/tabs/index.js";
    import ActivityChartNew from "@/Activities/ActivityChartNew.svelte";

    export let mapPolyline: Polyline = null
    export let mapUrl: string
    export let mpaData
    export let afterZoom: (data: [any], s: number, e: number) => void = null
    export let summary: Partial<SummaryData>

    // For bind
    export const show = () => {open = true}
    export let chartAvgDataOverSeconds: number
    export let onSliderInput: () => void = null

    let mapController: MapController
    let open: boolean
</script>


<Sheet.Root bind:open portal="#shadcn-ui-dialog-target">
    <Sheet.Content class="max-h-[96%] overflow-auto p-3 sm:p-6" side="bottom">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 px-4 py-2">
            <div class="flex flex-col flex-1">
                <div class="text-muted-foreground items-center justify-center grid grid-cols-2">
                    {#if onSliderInput}
                    <span class="text-muted-foreground text-sm font-medium">Activity Chart</span>
                    <div class='inline-flex items-center gap-2 ml-auto'>
                        <span>Rolling Average</span>
                        <SelectSlider class="w-auto" min={1} max={60} step={1} bind:value={chartAvgDataOverSeconds} on:input={onSliderInput} /> 
                        <span class="font-medium text-base">{chartAvgDataOverSeconds}s</span>
                    </div>
                    {/if}
                </div>
                <Separator class="mt-1 mb-2"/>
                <Am5Loader>
                    {#if !mapController.noop}
                        <ActivityChartNew
                            class="h-64"
                            {mpaData} 
                            map={{controller: mapController}} 
                            {afterZoom}
                            seriesVisibility={{
                                difficulty: "startHidden",
                                heartRate: "off",
                                targetPower: "off",
                                speed: "startHidden",
                                cadence: "startHidden",
                            }}
                        />
                    {/if}
                </Am5Loader>
            </div>

            {#if mpaData}
            <Tabs.Root value="map">
                <Tabs.List class="grid grid-cols-2">
                    <Tabs.Trigger value="analytics">Analytics</Tabs.Trigger>
                    <Tabs.Trigger value="map">Map</Tabs.Trigger>
                </Tabs.List>
                <Tabs.Content class="border rounded px-4 py-2 shadow-sm" value="analytics">
                    <MpaAnalyticsTable {summary} />
                </Tabs.Content>
                <Tabs.Content class="border rounded shadow-sm overflow-auto" value="map">
                    {#key [mapUrl, mapPolyline]}
                        <ActivityMap class="h-72" bind:mapController {mapPolyline} />
                    {/key}
                </Tabs.Content>
            </Tabs.Root>
            {/if}

        </div>
    </Sheet.Content>
</Sheet.Root>

<style lang="scss">
    .modal-tab-select-btn {
        background-color: transparent;
        border: none;
        color: #878787;
        font-weight: 600;
        cursor: pointer;
        box-sizing: border-box;
        border-style: solid;
        border-color: transparent;
        border-width: 5px 0;
        &:hover, &.active {
            color: black;
        }
        &:hover {
            border-color: transparent transparent #9fe4ea transparent;
        }
        &.active {
            border-color: transparent transparent #36c6d3 transparent;
        }
    }
</style>